import { useIntl } from 'react-intl'
import React from 'react'
import PriceRowCaption from 'LuxKit/PricePoints/PriceRowCaption'

interface Props {
  rooms: Array<App.Occupants>
}

export function BedbankTwinShare(props: Props) {
  const intl = useIntl()
  const {
    rooms,
  } = props

  const showLabel = rooms.length === 1 && rooms[0].adults === 2 && !rooms[0].children && !rooms[0].infants

  if (!showLabel) {
    return null
  }

  return <PriceRowCaption>{intl.formatMessage({
    id: 'LgAjSjBT48',
    defaultMessage: 'Twin share',
    description: 'Caption indicating the price is for a twin share room',
  })}
  </PriceRowCaption>
}

export default BedbankTwinShare
